import {Component, EventEmitter, Input, Output, OnChanges, SimpleChanges} from '@angular/core';
import {SistemaService} from '@servicios/Sistema.Service';
import {MensajeService} from '@mensaje/Mensaje.Service';
import {AppService} from '@api';
import {FiltroModel} from './Filtro.model';
import {TipoFiltroEnum} from './Filtros.enum';
import {AlertaEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {TranslateService} from '@ngx-translate/core';

@Component(
    {
        selector: 'filtros',
        templateUrl: './Filtros.template.html',
        styleUrls: ['./Filtros.scss'],
    })

export class FiltrosComponent implements OnChanges {
    @Input() urlApi: string = "";
    @Input() verBotonConsultar: boolean = true;
    @Input() verpanel: boolean = true;
    @Input() filtros: Array<FiltroModel> = [];
    @Output() filtroAplicado: EventEmitter<any> = new EventEmitter();

    public panelAbierto: boolean = false;
    public errorActivo: boolean = false;
    public animacion: string = '';

    public TipoFiltroEnum = TipoFiltroEnum;
    public filtrosOriginales: Array<FiltroModel> = [];
    public filtrosSeleccionados: Array<FiltroModel> = [];

    public tieneChips: boolean = false;
    public verLimpiar: boolean = false;

    constructor(public sistemaService: SistemaService, private mensajeService: MensajeService, public appService: AppService, public translate: TranslateService) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.filtros?.currentValue) {
            this.ChangeFiltros();
        }
    }

    ChangeFiltros() {
        this.filtrosOriginales = this.CloneFiltros(this.filtros);

        this.SetConfiguracionFiltros(true);
    }

    // --- Funcionamineto del panel
    AbrirPanel() {
        this.filtrosSeleccionados = this.CloneFiltros(this.filtros);

        this.animacion = 'slideInLeft ';
        this.panelAbierto = true;
        this.errorActivo = false;
    }

    CerrarPanel() {
        this.animacion = 'slideOutLeft ';

        setTimeout(() => {
            this.panelAbierto = false;
        }, 310);
    }

    CloneFiltros(datos: Array<FiltroModel>) {
        let filtros: Array<FiltroModel> = [];

        datos.forEach((filtro: FiltroModel) => {
            filtros.push({...filtro});
        });

        return filtros;
    }

    // ---- Funciones de filtros-------
    SetFiltros(filtros: Array<FiltroModel>, consultaInicial: boolean) {
        this.filtros = filtros;
        this.filtrosOriginales = this.CloneFiltros(filtros);

        if (consultaInicial) {
            this.Consultar(this.filtros, false);
        }

        this.SetConfiguracionFiltros(true);
    }

    Aplicar() {
        this.errorActivo = true;

        let validacion = this.ValidarFiltro();
        if (validacion) {
            this.MostrarErrorFiltros(validacion);
            return;
        }

        this.Consultar(this.filtrosSeleccionados, true);
    }

    MostrarErrorFiltros(error : string)
    {
        this.mensajeService.Alerta(AlertaEnum.Warning, error);
    }

    ValidarFiltro() {
        let mensajeError = "Completa todos los filtros correctamente.";

        for (let filtro of this.filtrosSeleccionados) {
            if (filtro.Obligatorio) {
                switch (filtro.TipoFiltro) {
                    case TipoFiltroEnum.Input:
                        if (!filtro.Valor) {
                            return mensajeError;
                        }
                        else if (filtro.Pattern) {
                            if (!filtro.Valor.match(filtro.Pattern)) {
                                return mensajeError;
                            }
                        }
                        break;

                    case TipoFiltroEnum.DropDown:
                        if (!filtro.Valor && filtro.Valor !== 0) {
                            return mensajeError;
                        }
                        break;

                    case TipoFiltroEnum.MultiSelect:
                    case TipoFiltroEnum.DropDownMulti:
                        if (filtro.Valor.length == 0) {
                            return mensajeError;
                        }

                        break;

                    case TipoFiltroEnum.RangoFecha:
                    case TipoFiltroEnum.Fecha:
                        if (!filtro.Valor) {
                            return mensajeError;
                        }
                        break;

                    default:
                        break;
                }
            }
        }

        return "";
    }

    ActualizarConsulta(filtrosAplicados: Array<FiltroModel>)
    {
        if (!this.filtrosSeleccionados || this.filtrosSeleccionados.length == 0)
        {
            this.filtrosSeleccionados = this.CloneFiltros(filtrosAplicados);
        }

        let validacion = this.ValidarFiltro();
        if (validacion) {
            this.MostrarErrorFiltros(validacion);
            return;
        }

        this.Consultar(filtrosAplicados);
    }


    Consultar(filtrosAplicados: Array<FiltroModel>, cambiarFiltros: boolean = false)
    {
        let modeloFiltros: any = {};

        filtrosAplicados.forEach((filtro: FiltroModel) => {
            modeloFiltros[filtro.Propiedad] = filtro.Valor;
        });

        this.appService.Post(this.urlApi, modeloFiltros).then(res => {
            this.filtroAplicado.emit(res.data);
            if (cambiarFiltros) {
                this.filtros = this.CloneFiltros(filtrosAplicados);
                this.SetConfiguracionFiltros(true);
            }
            if (this.panelAbierto) {
                this.CerrarPanel();
            }
        })
    }

    Reestablecer() {
        let indice = 0;

        this.filtrosSeleccionados.forEach((filtro: FiltroModel) => {
            switch (filtro.TipoFiltro) {
                case TipoFiltroEnum.Input:
                    filtro.Valor = '';
                    break;

                case TipoFiltroEnum.DropDown:
                    if (filtro.Obligatorio) {
                        filtro.Valor = this.filtrosOriginales[indice].Valor;
                    }
                    else {
                        filtro.Valor = null;
                    }

                    break;

                case TipoFiltroEnum.DropDownMulti:
                case TipoFiltroEnum.MultiSelect:
                    if (filtro.Obligatorio) {
                        filtro.Valor = this.filtrosOriginales[indice].Valor;
                    }
                    else {
                        filtro.Valor = [];
                    }
                    break;

                case TipoFiltroEnum.Fecha:
                    filtro.Valor = null;
                    break;

                case TipoFiltroEnum.RangoFecha:
                    filtro.Valor = null;
                    break;

                default:
                    break;
            }

            indice++;
        });
    }

    Limpiar() {
        this.filtrosSeleccionados = this.CloneFiltros(this.filtros);

        let indice = 0;
        this.filtrosSeleccionados.forEach((filtro: FiltroModel) => {
            if (!filtro.Obligatorio) {
                switch (filtro.TipoFiltro) {
                    case TipoFiltroEnum.Input:
                        filtro.Valor = '';

                        break;

                    case TipoFiltroEnum.DropDown:
                        filtro.Valor = null;
                        break;

                    case TipoFiltroEnum.DropDownMulti:
                    case TipoFiltroEnum.MultiSelect:
                        filtro.Valor = [];
                        break;

                    case TipoFiltroEnum.Fecha:
                        filtro.Valor = null;
                        break;

                    case TipoFiltroEnum.RangoFecha:
                        filtro.Valor = null;
                        break;

                    default:
                        break;
                }
            }
            else {
                filtro.Valor = this.filtrosOriginales[indice].Valor;
            }

            indice++;
        });

        this.Consultar(this.filtrosSeleccionados, true);
    }

    QuitarFiltro(filtro: FiltroModel) {
        if (filtro.Obligatorio) {
            return;
        }

        switch (filtro.TipoFiltro) {
            case TipoFiltroEnum.Input:
                filtro.Valor = "";
                break;

            case TipoFiltroEnum.DropDown:
                filtro.Valor = null;
                filtro.EtiquetasValor = "";
                break;

            case TipoFiltroEnum.Fecha:
            case TipoFiltroEnum.RangoFecha:
                filtro.Valor = null;
                break;

            default:
                break;
        }

        this.SetConfiguracionFiltros(false);
        this.Consultar(this.filtros);
    }

    QuitarFiltroMultiple(filtro: FiltroModel, dato: any, indice: number) {
        if (filtro.Obligatorio && filtro.Valor.length <= 1) {
            return;
        }

        this.sistemaService.BorrarElementoValorPorValor(filtro.Valor, dato);
        this.sistemaService.BorrarElementoValorPorValor(filtro.EtiquetasValor, filtro.EtiquetasValor[indice]);

        this.SetConfiguracionFiltros(false);
        this.Consultar(this.filtros);
    }

    SetConfiguracionFiltros(etiquetar: boolean)
    {
        if (etiquetar) {
            this.SetValorEtiquetaTodo();
        }

        this.TieneChips();
        this.VerLimpiar();
    }

    SetValorEtiquetaTodo() {
        this.filtros.forEach((filtro: FiltroModel) => {
            this.SetValorEtiqueta(filtro);
        });
    }

    SetValorEtiqueta(filtro: FiltroModel) {
        filtro.EtiquetasValor = null;

        if (filtro.TipoFiltro == TipoFiltroEnum.DropDown) {
            if (this.sistemaService.TieneValor(filtro.Valor)) {
                let elemento = filtro.Opciones.find(p => p[filtro.ValorName] === filtro.Valor);

                if (elemento) {
                    filtro.EtiquetasValor = elemento[filtro.DisplayValor];
                }
            }
        }
        else if (filtro.TipoFiltro == TipoFiltroEnum.DropDownMulti || filtro.TipoFiltro == TipoFiltroEnum.MultiSelect) {
            if (this.sistemaService.TieneValorArreglo(filtro.Valor)) {
                filtro.EtiquetasValor = [];

                filtro.Valor.forEach((valor: any) => {
                    let elemento = filtro.Opciones.find(p => p[filtro.ValorName] === valor);

                    if (elemento) {
                        filtro.EtiquetasValor.push(elemento[filtro.DisplayValor]);
                    }
                });
            }
        }
    }

    TieneChips() {
        for (let filtro of this.filtros) {
            switch (filtro.TipoFiltro) {
                case TipoFiltroEnum.Input:
                case TipoFiltroEnum.DropDown:
                case TipoFiltroEnum.Fecha:
                case TipoFiltroEnum.RangoFecha:
                    if (this.sistemaService.TieneValor(filtro.Valor)) {
                        this.tieneChips = true;
                        return;
                    }
                    break;

                case TipoFiltroEnum.MultiSelect:
                case TipoFiltroEnum.DropDownMulti:
                    if (this.sistemaService.TieneValorArreglo(filtro.Valor)) {
                        this.tieneChips = true;
                        return;
                    }
                    break;
            }
        }

        this.tieneChips = false;
    }

    VerLimpiar() {
        let indice = 0;
        for (let filtro of this.filtros) {
            if (filtro.Obligatorio) {
                switch (filtro.TipoFiltro) {
                    case TipoFiltroEnum.Input:
                    case TipoFiltroEnum.DropDown:
                    case TipoFiltroEnum.Fecha:
                    case TipoFiltroEnum.RangoFecha:
                        if (filtro.Valor !== this.filtrosOriginales[indice].Valor) {
                            this.verLimpiar = true;
                            return;
                        }
                        break;

                    case TipoFiltroEnum.MultiSelect:
                    case TipoFiltroEnum.DropDownMulti:
                        if (JSON.stringify(filtro.Valor) !== JSON.stringify(this.filtrosOriginales[indice].Valor)) {
                            this.verLimpiar = true;
                            return;
                        }
                        break;
                }
            }
            else {
                switch (filtro.TipoFiltro) {
                    case TipoFiltroEnum.Input:
                    case TipoFiltroEnum.DropDown:
                    case TipoFiltroEnum.Fecha:
                    case TipoFiltroEnum.RangoFecha:
                        if (this.sistemaService.TieneValor(filtro.Valor)) {
                            this.verLimpiar = true;
                            return;
                        }
                        break;

                    case TipoFiltroEnum.MultiSelect:
                    case TipoFiltroEnum.DropDownMulti:
                        if (this.sistemaService.TieneValorArreglo(filtro.Valor)) {
                            this.verLimpiar = true;
                            return;
                        }
                        break;
                }
            }

            indice++;
        }

        this.verLimpiar = false;
    }



    ModalChange(filtro: FiltroModel, valor: number)
    {
        if (filtro.Suscripcion) {
            filtro.Suscripcion.next(valor);
        }
    }
}
